module.exports = __webpack_public_path__ + "static/img/doosan-logo.f045168.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clientlogos/doosan-logo.jpg
// module id = dJQC
// module chunks = 1